export default {
    regSeason: {
        standings: [
            {manager: 'Zane', wins: 11, losses: 2, pf: 2423},
            {manager: 'Mike', wins: 11, losses: 2, pf: 2035},
            {manager: 'Steve', wins: 9, losses: 4, pf: 1868},
            {manager: 'Taylor', wins: 8, losses: 5, pf: 2139, champ: true},
            {manager: 'Scott', wins: 8, losses: 5, pf: 1979},
            {manager: 'Tommy', wins: 7, losses: 6, pf: 1906},
            {manager: 'Davis', wins: 7, losses: 6, pf: 1848},
            {manager: 'Aidan', wins: 6, losses: 7, pf: 1747},
            {manager: 'Tench', wins: 5, losses: 8, pf: 1536},
            {manager: 'Kieffer', wins: 4, losses: 9, pf: 1342},
            {manager: 'Conor', wins: 1, losses: 12, pf: 1567, sacko: true},
            {manager: 'Dan', wins: 1, losses: 12, pf: 1451}
        ]
    },
    playoffs: {
        teamData: {
            Zane: {
                seed: 1
            },
            Mike: {
                seed: 2
            },
            Steve: {
                seed: 3
            },
            Taylor: {
                seed: 4
            },
            Scott: {
                seed: 5
            },
            Tommy: {
                seed: 6
            }
        },
        gameData: [
            {
                name: 'Caleci-Fairlawn-Kennedy Championship Game',
                games: [
                    {
                        Mike: 122.2,
                        Taylor: 212
                    }
                ],
                props: {
                    winnerIcon: 'trophyGold bi bi-trophy-fill',
                    loserIcon: 'trophySilver bi bi-trophy-fill',
                }
            },
            {
                name: 'Thomas McGrath Award',
                games: [
                    {
                        Zane: 130.6,
                        Tommy: 116.7
                    }
                ],
                props: {
                    winnerIcon: 'trophyBronze bi bi-trophy-fill',
                }
            },
            {
                name: 'Semifinals',
                games: [
                    {
                        Zane: 115,
                        Taylor: 146.6
                    },
                    {
                        Mike: 155.2,
                        Tommy: 94.8
                    }
                ]
            },
            {
                name: 'Wildcard',
                games: [
                    {
                        Taylor: 173.1,
                        Scott: 134.5
                    },
                    {
                        Steve: 122.8,
                        Tommy: 133
                    }
                ]
            },
        ]
    },
    draft: {
        order: [
            'Aidan',
            'Zane',
            'Conor',
            'tench',
            'Steve',
            'Kieffer',
            'Mike',
            'Dan',
            'Scott',
            'Tommy',
            'Taylor',
            'Davis'
        ],
        picks: []
    }
}